import styled from 'styled-components';
import { REBRAND_COLOR, BREAKPOINT, PADDING, MARGIN } from '@/utils/constants';

export const SetupWrapper = styled.section`
  width: 100%;
  background: ${REBRAND_COLOR.WHITE};
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P32};

  @media (min-width: ${BREAKPOINT.MD}) {
    padding-top: ${PADDING.P64};
    padding-bottom: ${PADDING.P64};
  }
`;

export const SetupHeading = styled.div`
  margin-bottom: ${MARGIN.M24};

  @media (min-width: ${BREAKPOINT.MD}) {
    margin-bottom: ${MARGIN.M40};
  }
`;

export const SetupLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.M32};
  align-items: flex-start;

  @media (min-width: ${BREAKPOINT.MD}) {
    flex-direction: row;
    gap: ${MARGIN.M48};
    align-items: flex-start;
  }

  .select-list__item {
    border-top: 1px solid #ccddfd !important;
    border-bottom: 1px solid #ccddfd !important;
    color: ${REBRAND_COLOR.INDIGO};
  }


  .typography-base__cta--bold,
  .typography-base__cta--bold {
    color: ${REBRAND_COLOR.INDIGO} !important;
    font-weight: 600;
  }

  [class*="Text__StyledText-"] {
    color: ${REBRAND_COLOR.INDIGO} !important;
    font-weight: 500;
  }
  .accordion__item > .link-block.bg-stone {
    background-color: white !important;
    border: 1px solid var(--tint-black-40, #a4a7ae) !important;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .accordion__content--outlined {
    background-color: #ffffff !important;
    padding: 16px;
    border: 1px solid #A4A7AE;
    border-top: none;
    border-radius: 0 0 8px 8px;
}
    
`;

export const PhonePanel = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (min-width: ${BREAKPOINT.MD}) {
    justify-content: flex-start;
    width: auto;
    flex: 0 0 320px;
    position: sticky;
    top: ${PADDING.P32};
  }
`;

export const PhoneImage = styled.img`
  width: 100%;
  max-width: 280px;
  height: auto;
  display: block;
`;

export const AccordionListWrapper = styled.div`
  width: 100%;
  flex: 1 1 0%;
  min-width: 0;
`;

export const StyledSection = styled.div`
  .select-list__item {
    border-top: 1px solid #ccddfd !important;
    border-bottom: 1px solid #ccddfd !important;
    color: ${REBRAND_COLOR.INDIGO};
  }


  .typography-base__cta--bold,
  .typography-base__cta--bold {
    color: ${REBRAND_COLOR.INDIGO} !important;
    font-weight: 600;
  }

  [class*="Text__StyledText-"] {
    color: ${REBRAND_COLOR.INDIGO} !important;
    font-weight: 500;
  }
  .accordion__item > .link-block.bg-stone {
    background-color: white !important;
    border: 1px solid var(--tint-black-40, #a4a7ae) !important;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .accordion__item .bg-black-10 {
    padding: 16px;
    border: 1px solid var(--tint-black-40, #a4a7ae) !important;
    border-radius: 8px;
    border-top: none;
  }
`;
